import api from '../requests';


export async function getOrderBook(query) {

  const response = await api.request({
    method: 'get',
    url: `/internal/order-book`,
    params: {
      symbol: query.symbol,
      type: query.systemType
    },
  });
  return response.data;
}

